























































import { Vue, Component, Prop } from 'vue-property-decorator';

import InputError from '~/components/inputs/InputError.vue';
import EyeOutline from '~/components/icons/EyeOutline.vue';

@Component({
  components: { InputError, EyeOutline },
})
export default class PasswordInput extends Vue {
  @Prop(String) label: '';
  @Prop(String) placeholder: '';
  @Prop(String) value: '';
  @Prop(Object) v: () => ({});
  @Prop(Object) vMessages: () => ({});
  @Prop(Boolean) autofocus: false;
  @Prop(Boolean) showHints: false;

  passwordVisible: boolean = false;

  $refs: {
    input: HTMLInputElement,
    toggleIcon: HTMLDivElement,
  };

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }

  /*
    Computed will listen every other events listened by the input, and catchable
    in the parent itself
  */
  get listenersExceptInput () {
    /* eslint-disable-next-line */
    const { input: _, ...otherListeners } = this.$listeners;
    return otherListeners;
  }

  mounted () {
    if (this.autofocus) this.$refs.input.focus();

    // Auto-adapt a padding-right for the container so the "eye" icon is well
    // displayed, as it's an absolute element in template
    const iconWidth = this.$refs.toggleIcon.getBoundingClientRect().width;
    this.$refs.input.style.paddingRight = `${iconWidth}px`;
  }
};
